module.exports = __webpack_public_path__ + "img/2025-11-17a_1.88bad78c.jpg";